import React, { useState, useEffect, useCallback } from "react"
import "./AppHeader.css"
import SecondHeader from "./SecondHeader/SecondHeader.jsx"
import ThirdHeader from "./ThirdHeader/ThirdHeader.jsx"
import logo from "./../../../assets/icons/aris_insights.svg"
import logo_green from "./../../../assets/icons/aris-insights-green.svg"
import location_building from "./../../../assets/icons/location_building.svg";
import recent_icon from "./../../../assets/icons/recent_gray.svg";
import screens_icon from "./../../../assets/icons/screens_gray.svg";
import overview_grid from "./../../../assets/icons/overview_grid.svg";
import roll_out_icon from "./../../../assets/icons/roll_out_gray.svg";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import { signOut } from 'firebase/auth';
import { ref, getDownloadURL } from 'firebase/storage';
import { collection, onSnapshot } from 'firebase/firestore';
import { auth, db, storage } from './../../../firebase';
import { useUser } from "./../../../contexts/UserContext.js";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
	filterSortableWasteReceivers,
	normalizeWasteReceiverDoc,
	WASTE_RECEIVERS_COLLECTION,
} from '../../../common/wasteReceivers.js';

const AppHeader = () => {
	const { t } = useTranslation();
	const { userData } = useUser();
	const navigate = useNavigate();
	const { unitId, displayUnitIndex, wadeReportMode } = useParams();
	const headerUnitRouteSegment = displayUnitIndex ?? unitId;
	const [logout_dropdown_show, set_logout_dropdown_show] = useState(false)
	const location = useLocation();
	const [isWadeReportMode, setIsWadeReportMode] = useState(false);

	const navigateToHome = useCallback(() => {
		navigate('/')
	}, [navigate]);

	const userButtonClicked = useCallback(() => {
		set_logout_dropdown_show(!logout_dropdown_show)
	}, [logout_dropdown_show])

	useEffect(() => {
		const handlePageClick = (event) => {
			if (!event.target.closest('.user-button')) {
				set_logout_dropdown_show(false);
			}		
		};
	
		document.addEventListener('click', handlePageClick);
	
		return () => {
		  document.removeEventListener('click', handlePageClick);
		};
	  }, []);

	  useEffect(() => {
		/*
        const queryParams = new URLSearchParams(location.search);
		////console.log("wadeReportMode header", wadeReportMode)
        const isWadeReportMode = (queryParams.get('wade_report_mode') === 'true') || wadeReportMode == "month";
        const wadeReportTimeIsMonth = queryParams.get('wade_report_time') == "month" || wadeReportMode == "month";
        setIsWadeReportMode(isWadeReportMode)
        setIsWadeReportTimeMonth(wadeReportTimeIsMonth)
		*/
		location.pathname.includes('wade-report-mode') && setIsWadeReportMode(true)
		////console.log("wadeReportMode header 2", location.pathname)
    }, [location])

	useEffect(() => {
		/*
		////console.log("wadeReportMode header", wadeReportMode)
		setIsWadeReportMode(wadeReportMode)
        setIsWadeReportTimeMonth(wadeReportMode)*/
	}, [wadeReportMode])

	const [logoFileName, setLogoFileName] = useState(null);
	const [logoUrl, setLogoUrl] = useState(null);
	const [selectedTab, setSelectedTab] = useState(0);
	const [canSeeSortingListNav, setCanSeeSortingListNav] = useState(false);
	const [wasteReceivers, setWasteReceivers] = useState([]);
	const currentUserIdentityLabel = String(
		userData?.name ||
		userData?.email ||
		userData?.mail ||
		userData?.user_id ||
		auth.currentUser?.uid ||
		'',
	).trim();

	const loadImage = async () => {
        
		if (!logoFileName) {
			return;
		}
        const imgRef = ref(storage, `wade_report/partner_logos/${logoFileName}`);

        try {
            const url = await getDownloadURL(imgRef);
            setLogoUrl(url);
        } catch (error) {
			////console.log("Error loading logo image", error);
        }
    };

	useEffect(() => {
		loadImage();
	}, [logoFileName])

	useEffect(() => {
        const queryParams = new URLSearchParams(location.search);

        queryParams.get("logo-file-name") && setLogoFileName(queryParams.get("logo-file-name"))
        
    }, [location])

	useEffect(() => {
		if (location.pathname.includes('screens')) {
			setSelectedTab(2);
		} else if (location.pathname.includes('recent')) {
			setSelectedTab(1);
		} else if (location.pathname.includes('admin-overview')) {
			setSelectedTab(3);
		} else if (location.pathname.includes('roll-out')) {
			setSelectedTab(4);
		} else if (location.pathname.includes('dangerous-waste/sorting-lists')) {
			setSelectedTab(5);
		} else if (location.pathname.includes('setup')) {
			setSelectedTab(6);
		} else {
			setSelectedTab(0);
		}
	}, [location]);

	useEffect(() => {
		const unsubscribe = onSnapshot(
			collection(db, WASTE_RECEIVERS_COLLECTION),
			(snap) => {
				const receivers = snap.docs
					.map(normalizeWasteReceiverDoc)
					.sort((a, b) => {
						const nameCompare = (a.name || a.id).localeCompare(b.name || b.id);
						return nameCompare || a.id.localeCompare(b.id);
					});
				setWasteReceivers(receivers);
			},
			(error) => {
				console.error('Error loading waste receivers for navigation:', error);
				setWasteReceivers([]);
			},
		);

		return unsubscribe;
	}, []);

	useEffect(() => {
		setCanSeeSortingListNav(
			filterSortableWasteReceivers(userData, wasteReceivers).length > 0,
		);
	}, [userData, wasteReceivers]);

	return (
		<div className="AppHeader">
			{ !location.pathname.includes('admin') &&
				<div 
					className="main-wrapper"
					style={{
						"borderBottom": isWadeReportMode ? "none" : "1px solid var(--gray-700)"
					}}
				>
					<div className="flex-wrapper">
						{ isWadeReportMode?
						<img 
							className="logo" 
							src={logo_green} 
							alt="Aris Insights"
							onClick={()=>{navigateToHome()}}
							style={{"cursor": "pointer"}}
						/>
						: <img 
							className="logo" 
							src={logo} 
							alt="Aris Insights"
							onClick={()=>{navigateToHome()}}
							style={{"cursor": "pointer"}}
						/>
						}
					</div>

					{ isWadeReportMode 
					? (
						<div className="wadeReportModeLogo">
							<img 
								src={logoUrl}
								alt="Logo"
							/>
						</div>
					)
					: (
						userData &&
						<div className="toggle">
							<div className="toggle-active"></div>
								<div 
									className="inner-toggle"
									onClick={()=>{navigate('/')}}
								>
								<img className="tiny-icon" src={location_building} alt=""/>
								<div 
									className={`toggle-text ${selectedTab === 0 ? 'selected-toggle-text' : ''}`}
								>
									{t("Lokationer")}
									</div>
								</div>
								{canSeeSortingListNav && (
									<div
										className="inner-toggle"
										onClick={()=>{navigate('/dangerous-waste/sorting-lists')}}
									>
										<FormatListBulletedIcon className="tiny-icon" fontSize="small" />
										<div
											className={`${selectedTab === 5 ? 'selected-toggle-text' : 'toggle-text'}`}
										>
											Sorteringsliste
										</div>
									</div>
								)}
								{userData.isAdmin && (
									<>
								<div 
									className="inner-toggle"
								onClick={()=>{navigate('/recent')}}
							>
								<img className="tiny-icon" src={recent_icon} alt=""/>
								<div 
									className={`${selectedTab === 1 ? 'selected-toggle-text' : 'toggle-text'}`}
								>
									{t("Seneste")}
								</div>
							</div>
							<div 
								className="inner-toggle"
								onClick={()=>{navigate('/screens')}}
							>
								<img className="tiny-icon" src={screens_icon} alt=""/>
								<div 
									className={`${selectedTab === 2 ? 'selected-toggle-text' : 'toggle-text'}`}
								>
									Skærme
								</div>
							</div>
							<div 
								className="inner-toggle"
								onClick={()=>{navigate('/admin')}}
							>
								<img className="tiny-icon" src={overview_grid} alt=""/>
								<div 
									className={`${selectedTab === 3 ? 'selected-toggle-text' : 'toggle-text'}`}
								>
									Admin overblik
								</div>
							</div>
							<div 
								className="inner-toggle"
								onClick={()=>{navigate('/roll-out')}}
							>
								<img className="tiny-icon" src={roll_out_icon} alt=""/>
								<div 
									className={`${selectedTab === 4 ? 'selected-toggle-text' : 'toggle-text'}`}
								>
									{t("Udrulning")}
								</div>
							</div>
							<div 
								className="inner-toggle"
								onClick={()=>{navigate('/setup')}}
							>
								<SettingsSuggestIcon className="tiny-icon" fontSize="small" />
								<div 
									className={`${selectedTab === 6 ? 'selected-toggle-text' : 'toggle-text'}`}
								>
									Setup
								</div>
							</div>
								</>
							)}
						</div>
					)}
					{ !isWadeReportMode && (
						<div className="flex-wrapper">
							<div className="user-button-wrapper">
								<div 
									className="user-button" 
									onClick={ () => {
										userButtonClicked()
									}}
									style={{"backgroundColor": (userData ? userData["color"] : "")}}
								>
									<div className="icon-text">
										{ (userData && userData["name"]) ? userData["name"].slice(0, 2).toUpperCase() : '' }
									</div>
								</div>
								{logout_dropdown_show && (
									<div className="header-dropdown-menu">
										<div className="header-dropdown-identity">
											{t("Bruger")}: {currentUserIdentityLabel || '-'}
										</div>
										<button className="aris-button-secondary header-dropdown-action" onClick={()=>{signOut(auth)}}
											type="submit">
											{t("Log ud")}
										</button>
									</div>
								)}
							</div>
						</div>
					)}
				</div>
				}
				{(location.pathname.includes('locations/') || location.pathname.includes('unit/')) && <SecondHeader unitId={headerUnitRouteSegment} isWadeReportMode={isWadeReportMode}/>}
				{(!isWadeReportMode && location.pathname.includes('unit/')) && <ThirdHeader />}
			
		</div>
	);
}

export default AppHeader
